// on the wepback @sentry/node is mapped to @sentry/browser for client-side code
// this trick is need to make this code isomorphic
import * as Sentry from "@sentry/node";
import { Integrations } from "@sentry/tracing";
import { jwtPayload } from "@insightfulscience/shared-utils/jwt/jwtPayload";
import { Dedupe } from "@sentry/integrations";
import { Token } from "./persistent-storage";
import { publicConfig } from "./config";
import pack from "../package.json";
import { getEnvName } from "./utils/parseEnvName";

const { version } = pack;

const { SENTRY_DSN, ENV, SENTRY_TRACING_RATE } = publicConfig;

export const assignScope = context =>
	Sentry.configureScope(scope => {
		scope.setUser(jwtPayload(Token(context.ctx || context).get()));

		if (context == null) return;

		const route = context?.asPath ? context.asPath.replace(/\//g, ".") : "";

		scope.setContext("query", context.query);
		scope.setExtra("route", route);
		scope.addBreadcrumb({
			category: "query-path",
			message: route,
			level: "debug",
		});
	});

export const notifySentry = (err, context) => {
	assignScope(context);
	Sentry.captureException(err, {
		tags: {
			...err.tags, //
			errorClass: err.constructor.name,
		},
	});
	return err;
};

export const initSentry = context => {
	if (!SENTRY_DSN) return;

	const sentryConfig = {
		release: version,
		dsn: SENTRY_DSN,
		environment: getEnvName(ENV || "development").toLowerCase(),
		integrations: [new Integrations.BrowserTracing(), new Dedupe()],
		tracesSampleRate: SENTRY_TRACING_RATE != null ? parseFloat(SENTRY_TRACING_RATE) : 0,
		ignoreErrors: ["Non-Error exception captured", "Non-Error promise rejection captured"],
	};

	Sentry.init(sentryConfig);

	if (context) assignScope(context);
};
